import { Tag, Typography } from 'antd';
import moment from 'moment';
import { ITS_DATA_VALID_YEARS, ITS_FIELD_LABELS } from '../util/ITS';

const { Text } = Typography;

// filterItems keys that hold styling rather than a filter.
const NON_FILTER_KEYS = ['color', 'values'];

const formatValue = (value) => {
  if (moment.isMoment(value)) return value.format('YYYY-MM-DD');
  return String(value);
};

// One filter's values as display text: a numeric or date range for a
// two-element [min, max], otherwise the selected values.
const describeValues = (value) => {
  if (!Array.isArray(value)) return formatValue(value);
  if (
    value.length === 2 &&
    (value.every((v) => typeof v === 'number') ||
      value.every((v) => moment.isMoment(v)))
  ) {
    return `${formatValue(value[0])} – ${formatValue(value[1])}`;
  }
  return value.map(formatValue).join(', ');
};

const isDefaultYears = (field, value) =>
  field === 'year_txt' &&
  Array.isArray(value) &&
  value.length === ITS_DATA_VALID_YEARS.year_txt.length &&
  ITS_DATA_VALID_YEARS.year_txt.every((year) => value.includes(year));

// Filters in effect on a layer, from its filterItems entry. ITS layers
// always carry every valid year by default, which isn't shown as a filter.
const getAppliedFilters = (filters) =>
  Object.entries(filters ?? {}).filter(
    ([field, value]) =>
      !NON_FILTER_KEYS.includes(field) &&
      value !== undefined &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0) &&
      value !== '' &&
      !isDefaultYears(field, value)
  );

// The filters applied to a layer, shown in the sidebar so they're visible
// without reopening the filter modal. Each can be removed on its own.
const AppliedFilters = (props) => {
  const { filters, onRemove } = props;
  const applied = getAppliedFilters(filters);
  if (applied.length === 0) return null;

  return (
    <div style={{ margin: '2px 0 8px' }}>
      <Text style={{ fontSize: 12, color: '#2C3E37' }}>Applied filters:</Text>
      <div
        style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: 2 }}
      >
        {applied.map(([field, value]) => {
          const label = ITS_FIELD_LABELS[field] ?? field;
          const text = describeValues(value);
          return (
            <Tag
              key={field}
              closable
              closeIcon={
                <span aria-label={`Remove ${label} filter`} role="button">
                  ×
                </span>
              }
              onClose={(event) => {
                event.preventDefault();
                onRemove(field);
              }}
              title={`${label}: ${text}`}
              style={{
                margin: 0,
                maxWidth: '100%',
                whiteSpace: 'normal',
                fontSize: 12,
                backgroundColor: '#F4F7F5',
                borderColor: '#B9CBC3',
                color: '#2C3E37',
              }}
            >
              <strong>{label}:</strong> {text}
            </Tag>
          );
        })}
      </div>
    </div>
  );
};

export { getAppliedFilters };
export default AppliedFilters;
